import React from 'react';
import ProjectLegacyRedirect from '../components/projects/ProjectLegacyRedirect';

/**
 * Legacy top-level project URLs (`/projects/:id/artifacts` …) that redirect
 * into the phase-scoped workspace. Everything else that used to be
 * re-exported from here was unrouted and has been removed.
 */
export const ProjectLegacyArtifactsPage = () => <ProjectLegacyRedirect to="artifacts" />;
export const ProjectLegacyReportPage = () => <ProjectLegacyRedirect to="report" />;
export const ProjectLegacyHandoffPage = () => <ProjectLegacyRedirect to="handoff" />;
export const ProjectLegacyIntakePage = () => <ProjectLegacyRedirect to="intake" />;
export const ProjectLegacyScanPage = () => <ProjectLegacyRedirect to="scan" />;
